export const transformParamToFilter = (param) => {
  if (typeof param === 'string') {
    return isValidParam(param) ? { [param]: true } : {};
  } else {
    return param
      ? param.reduce(
          (acc, cur) => (isValidParam(cur) ? { ...acc, [cur]: true } : acc),
          {}
        )
      : {};
  }
};

export const isValidParam = (param) => {
  return typeof param === 'string' && param.length > 0;
};
